"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _core = require("@material-ui/core");
var _componentsLibrary = require("components-library");
var _react = _interopRequireWildcard(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _EditorDisplay = _interopRequireDefault(require("../EditorDisplay/EditorDisplay"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    root: {
      background: "rgba(0,0,0,0.02)",
      borderTop: "1px solid rgba(0,0,0,0.07)",
      paddingTop: theme.spacing(5),
      paddingBottom: theme.spacing(5),
      marginTop: theme.spacing(5)
    },
    copywrite: {
      textAlign: "center"
    }
  };
});
function Footer(_ref) {
  var siteName = _ref.siteName,
    cols = _ref.cols,
    iframeLink = _ref.iframeLink,
    iframeTitle = _ref.iframeTitle,
    termsLink = _ref.termsLink,
    useLoad = _ref.useLoad;
  var _useStyles = useStyles(),
    root = _useStyles.root,
    copywrite = _useStyles.copywrite;
  var columns = (0, _react.useMemo)(function () {
    return (cols || []).filter(function (c) {
      return c !== "" && c !== "<p></p>";
    });
  }, [cols]);
  return /*#__PURE__*/_react["default"].createElement("footer", {
    className: root
  }, /*#__PURE__*/_react["default"].createElement(_core.Container, null, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    container: true,
    spacing: 5
  }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    sm: 6,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_core.Box, {
    mb: 3,
    sx: {
      width: 200
    }
  }, /*#__PURE__*/_react["default"].createElement(_componentsLibrary.Brand, {
    useLoad: useLoad
  })), /*#__PURE__*/_react["default"].createElement(_core.Typography, null, "Whatever your occasion we\u2019re confident we can find an ideal boat \u2013 simply tell us what you\u2019re looking for and we\u2019ll do all the hard work for you!")), iframeTitle || iframeLink ? /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    sm: 6,
    xs: 12
  }, iframeTitle && /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    gutterBottom: true,
    variant: "h6"
  }, iframeTitle), iframeLink && /*#__PURE__*/_react["default"].createElement(_core.Box, {
    sx: {
      width: "100%",
      overflow: "hidden",
      position: "relative",
      "&:before": {
        content: "''",
        display: "block",
        paddingTop: "26%"
      },
      "& iframe": {
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        width: "100%",
        height: "100%",
        border: 0
      }
    }
  }, /*#__PURE__*/_react["default"].createElement("iframe", {
    src: iframeLink.includes("?") ? iframeLink + "&width=10000" : iframeLink + "?width=10000"
  }))) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    sm: 3,
    xs: 12
  }), /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    sm: 3,
    xs: 12
  })), /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_core.Divider, null)), columns && columns.length > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    xs: 12,
    container: true,
    spacing: 2
  }, cols.map(function (m, i) {
    return /*#__PURE__*/_react["default"].createElement(_core.Grid, {
      key: i,
      item: true,
      sm: columns.length >= 4 ? 3 : columns.length >= 3 ? 4 : columns.length >= 2 ? 6 : 12,
      xs: 12
    }, /*#__PURE__*/_react["default"].createElement(_EditorDisplay["default"], {
      content: m
    }));
  })), /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_core.Divider, null))), /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "body2",
    className: copywrite
  }, "Copyright ", (0, _moment["default"])().format("YYYY"), " | ", siteName, " Pty Ltd | All rights reserved", termsLink && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, " ", "| ", /*#__PURE__*/_react["default"].createElement(_core.Link, {
    href: termsLink
  }, "Terms and Conditions")))))));
}
var _default = exports["default"] = Footer;